// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

export enum FitModes {
    FitWidth = 'FitWidth',
    FitPage = 'FitPage',
    Zoom = 'Zoom',
}
